export const BRAND_SECTION_TRANSLATIONS = {
  homeAriaLabel: {
    "pt-BR": "Voltar para o site",
    en: "Back to site",
    es: "Volver al sitio",
    de: "Zurück zur Website",
  },
  headline: {
    "pt-BR": "Cuidado contínuo, conexão verdadeira.",
    en: "Continuous care, real connection.",
    es: "Cuidado continuo, conexión verdadera.",
    de: "Kontinuierliche Betreuung, echte Verbindung.",
  },
  subhead: {
    "pt-BR": "Famílias que evoluem juntas.",
    en: "Families that grow together.",
    es: "Familias que evolucionan juntas.",
    de: "Familien, die zusammenwachsen.",
  },
  body: {
    "pt-BR": "Onde paciente, responsável e terapeuta caminham juntos no processo terapêutico.",
    en: "Where patient, guardian, and therapist walk together through the therapeutic process.",
    es: "Donde paciente, responsable y terapeuta caminan juntos en el proceso terapéutico.",
    de: "Dabei gehen Patient, Betreuer und Therapeut gemeinsam durch den therapeutischen Prozess.",
  },
  featureSecureTitle: { "pt-BR": "Seguro", en: "Secure", es: "Seguro" , de: "Sicher"},
  featureSecureDescription: {
    "pt-BR": "Seus dados protegidos com segurança.",
    en: "Your data protected with care.",
    es: "Tus datos protegidos con seguridad.",
    de: "Ihre Daten werden sorgfältig geschützt.",
  },
  featureAccompaniedTitle: { "pt-BR": "Acompanhado", en: "Supported", es: "Acompañado" , de: "Unterstützt"},
  featureAccompaniedDescription: {
    "pt-BR": "Todos conectados no mesmo propósito.",
    en: "Everyone connected around the same purpose.",
    es: "Todos conectados en el mismo propósito.",
    de: "Alle haben das gleiche Ziel verfolgt.",
  },
  featureHumanTitle: { "pt-BR": "Humano", en: "Human", es: "Humano" , de: "Menschlich"},
  featureHumanDescription: {
    "pt-BR": "Tecnologia a serviço de pessoas.",
    en: "Technology in service of people.",
    es: "Tecnología al servicio de las personas.",
    de: "Technologie im Dienste der Menschen.",
  },
} as const;

export const PASSWORD_CONFIRM_TRANSLATIONS = {
  passwordLabel: { "pt-BR": "Senha", en: "Password", es: "Contraseña" , de: "Passwort"},
  confirmLabel: { "pt-BR": "Confirmar senha", en: "Confirm password", es: "Confirmar contraseña" , de: "Passwort bestätigen"},
  passwordPlaceholder: {
    "pt-BR": "Mínimo 8 caracteres",
    en: "Minimum 8 characters",
    es: "Mínimo 8 caracteres",
    de: "Mindestens 8 Zeichen",
  },
  confirmPlaceholder: {
    "pt-BR": "Repita a senha",
    en: "Repeat password",
    es: "Repite la contraseña",
    de: "Passwort wiederholen",
  },
} as const;

export const SOCIAL_SIGN_IN_TRANSLATIONS = {
  groupAriaLabel: { "pt-BR": "Login social", en: "Social login", es: "Inicio de sesión social" , de: "Soziales Login"},
  signIn: { "pt-BR": "Entrar", en: "Sign in", es: "Entrar" , de: "anmelden"},
  continue: { "pt-BR": "Continuar", en: "Continue", es: "Continuar" , de: "Weitermachen"},
  withGoogle: { "pt-BR": "com Google", en: "with Google", es: "con Google" , de: "mit Google"},
  withApple: { "pt-BR": "com Apple", en: "with Apple", es: "con Apple" , de: "mit Apple"},
} as const;

export const REGISTRATION_CONSENT_TRANSLATIONS = {
  sectionTitle: {
    "pt-BR": "Privacidade e termos",
    en: "Privacy and terms",
    es: "Privacidad y términos",
    de: "Datenschutz und Bedingungen",
  },
  loadingPlan: {
    "pt-BR": "Carregando informações do plano…",
    en: "Loading plan information…",
    es: "Cargando información del plan…",
    de: "Planinformationen werden geladen…",
  },
  acceptTermsPrefix: { "pt-BR": "Li e aceito os", en: "I have read and accept the", es: "He leído y acepto los" , de: "Ich habe die gelesen und akzeptiere sie"},
  termsOfUse: { "pt-BR": "Termos de Uso", en: "Terms of Use", es: "Términos de Uso" , de: "Nutzungsbedingungen"},
  acceptTermsSuffix: { "pt-BR": "do Mivo.", en: "of Mivo.", es: "de Mivo." , de: "von Mivo."},
  acceptPrivacyPrefix: { "pt-BR": "Li e aceito a", en: "I have read and accept the", es: "He leído y acepto la" , de: "Ich habe die gelesen und akzeptiere sie"},
  privacyPolicy: {
    "pt-BR": "Política de Privacidade",
    en: "Privacy Policy",
    es: "Política de Privacidad",
    de: "Datenschutzrichtlinie",
  },
  acceptPrivacySuffix: { "pt-BR": "do Mivo.", en: "of Mivo.", es: "de Mivo." , de: "von Mivo."},
  scrollToAccept: {
    "pt-BR": "Role até o final do documento para habilitar o botão de aceite.",
    en: "Scroll to the end of the document to enable the accept button.",
    es: "Desplázate hasta el final del documento para habilitar el botón de aceptación.",
    de: "Scrollen Sie zum Ende des Dokuments, um die Schaltfläche „Akzeptieren“ zu aktivieren.",
  },
} as const;
